// @ts-nocheck
/** Policy limits for persisted template item variables (DEC-049 / list addendum). */
export const ITEM_VARIABLE_POLICY = {
  maxKeysPerItem: 48,
  maxKeyLength: 64,
  maxStringBytes: 4096,
  /** Soft cap on heterogeneous list element count (DEC-069 / DEC-076 catalog). */
  maxListElements: 256,
  maxJsonBytes: 131072,
  keyPattern: /^[A-Za-z0-9_.-]+$/,
} as const;

/** Types accepted by `setItemVariable` / `writeVariable`. */
export type ItemVariableType =
  | 'string'
  | 'integer'
  | 'float'
  | 'boolean'
  | 'color'
  | 'datetime'
  | 'itemRef'
  | 'list';

/**
 * Legacy bag tags that may still appear in persisted JSON.
 * Not writable via host/`writeVariable` (category CTBL owns real tables).
 */
export type ItemVariableLegacyType = 'table' | 'fileTable';

export type PersistedItemVariableType = ItemVariableType | ItemVariableLegacyType;

export interface ItemVariableEntry {
  t: PersistedItemVariableType;
  /**
   * Stored value. Scalars / null for most types; arrays for `list`.
   * Legacy `table`/`fileTable` entries may still hold CTBL/manifest strings.
   */
  v: string | number | boolean | null | ReadonlyArray<unknown>;
}

export type ItemVariableBag = Record<string, ItemVariableEntry>;

export type ItemVariableErrorCode =
  | 'invalid_key'
  | 'invalid_type'
  | 'invalid_value'
  | 'type_mismatch'
  | 'limit_keys'
  | 'limit_string'
  | 'limit_json'
  | 'limit_list'
  | 'invalid_color';
